import React, { useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import {
  FaFacebook,
  FaLinkedin,
  FaInstagram,
  } from "react-icons/fa";
import emailjs from "emailjs-com";
const Contact = () => {
  const [formData, setFormData] = useState({
    to_name: "",
    lastName: "",
    from_name: "",
    message: "",
  });
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    emailjs
      .send(
        "service_t88t8oo", // Replace with your EmailJS Service ID
        "template_9mswzof", // Replace with your EmailJS Template ID
        formData,
        "nM1WL_t6ADlx7Ainy" // Replace with your EmailJS User ID
      )
      .then(
        (response) => {
         
          setFormData({
            to_name: "",
            lastName: "",
            from_name: "",
            message: "",
          });
        },
        (error) => {
          console.error("Failed to send message", error);
        }
      );
  };

  return (
    <>
      <Container className="justify-content-center align-items-center">
        <Row className="vh-10">
          <Col md={6}>
            <div className="mb-31">
              <p>
             <br/><br/> I am available for commercial camera work, but if you're crafting a story that needs a cinematic eye - whether it's a passion project or a big-budget production - I’d love to hear about it. I’m driven by bold storytelling and striking imagery, and I'm always looking to collaborate on projects that bring unique ideas to life through powerful visuals. </p>
            </div>
            <div className="mt-4 d-flex justify-content-center">
              <p>+642102854467  | clintthambi@gmail.com</p>
            </div>
            <div className="mt-4 d-flex justify-content-center">
             
              <a
                href="https://www.linkedin.com/in/clint-thambi-7359a62b2/"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
              >
                <FaLinkedin size={30} color="#a17c0c" />
              </a>
              <a
                href="https://www.instagram.com/cinedriftproductions"
                target="_blank"
                rel="noopener noreferrer"
                className="me-3"
              >
                <FaInstagram size={30} color="#a17c0c" />
              </a>
            </div>
          </Col>
          <Col md={{ span: 6 }}>
            <Form onSubmit={handleSubmit}>
              {/* Row for First Name and Last Name */}
              <Row className="mb-3">
                <Col>
                  <Form.Group controlId="formFirstName">
                    <Form.Label>First Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="to_name"
                      value={formData.to_name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId="formLastName">
                    <Form.Label>Last Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      placeholder="Enter Last Name"
                    />
                  </Form.Group>
                </Col>
              </Row>

              {/* Row for Email Address */}
              <Form.Group className="mb-3" controlId="formEmail">
                <Form.Label>Email Address</Form.Label>
                <Form.Control
                  type="email"
                  name="from_name"
                  value={formData.from_name}
                  onChange={handleChange}
                  placeholder="Enter Email"
                />
              </Form.Group>
              <Form.Group className="mb-3" controlId="formTextBox">
                <Form.Label>Message</Form.Label>
                <Form.Control
                  as="textarea"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Enter your message"
                />
              </Form.Group>
              {/* Submit Button */}
              <Button variant="secondary" type="submit">
                Submit
              </Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Contact;
